import api, { ValidateAxiosError, } from '@/modules/api.service';
import { CreateComarcaDto, ReadComarcaDto, UpdateComarcaDto } from '@/api.types';
import { Endpoints } from '@/shared/constants/endpoints';
import { FindComarcaDto } from '@/api.types.extra';

const endpoint = Endpoints.COMARCA;

export async function createComarca(dto: CreateComarcaDto) {
  try {
    const response = await api.post(endpoint, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao cadastrar a comarca.');
  }
}

export async function readComarca(filters: FindComarcaDto) {
  if (filters) {
    filters.skip ??= 0;
    filters.take ??= 10;
  }

  try {
    const response = await api.get<[ReadComarcaDto[], number]>(endpoint, { params: filters });
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao buscar comarca(s).');
  }
}

export async function readComarcaPublic(filters: FindComarcaDto) {
  if (filters) {
    filters.skip ??= 0;
    filters.take ??= 10;
  }

  try {
    const response = await api.get<[ReadComarcaDto[], number]>(endpoint + '/public', { params: filters });
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao buscar comarca(s).');
  }
}

export async function updateComarca(dto: UpdateComarcaDto) {
  try {
    const response = await api.put(endpoint, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao atualizar a comarca.');
  }
}

export async function deleteComarca(id: number) {

  try {
    const response = await api.delete(endpoint + '/' + id)
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao remover a comarca.');
  }
}